import React from 'react';

function AboutMe(){
    return (
      <>
        <section id="intro" className="link-section flex-container responsive">
            <div id="section-container" >
                <div className="section-left">
                  <h1 className="section-heading">MERN Full Stack Web Developer in Sydney, Australia</h1>
                  <p>
                  I'm a Sydney based Web Developer leveraged with Sales and Marketing backgrounds to create professional websites. Currently undertaking University of Sydney Full Stack Web Development Certificate developing skills in HTML, CSS, JavaScript, MERN and MySQL. 
                  I enjoy Coffee, Fitness and Music.
                  </p>
                  <a className="call-to-action" href="#portfolio">See My Projects</a>
                  <a className="call-to-action" href="https://docs.google.com/document/d/1OYmB9IP4HNri-aF_rYoc92nmU7PC5D74/edit">Resume</a>
                </div>
                <div id="creativity-banner-scroll" className="picture-scroll section-right"></div>
            </div>
        </section>    
      </>   
    )
}

export default AboutMe;